import * as z from "zod";

const imageSchema = z.object({
  src: z.string().nullable(),
  altText: z.string().nullable(),
});

// Mirrors the frontend ModalProduct / ModalVariants shape so the RPC output can
// be handed straight to the product-selection modal.
const pickerVariantSchema = z.object({
  admin_graphql_api_id: z.string(),
  inventory_quantity: z.number().optional(),
  sku: z.string().nullish(),
  title: z.string(),
  requires_shipping: z.boolean().optional(),
  price: z.string(),
  image: imageSchema,
  productTitle: z.string().optional(),
});

const pickerProductSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  handle: z.string(),
  image: imageSchema,
  images: z.array(imageSchema),
  tags: z.array(z.string()),
  onlineStoreUrl: z.string().optional(),
  variants: z.array(pickerVariantSchema),
});

// Named specifically for the post-purchase upsell manual product picker: this
// RPC always excludes Shopify Combined Listing parents (only reliably detectable
// via the Admin API), so combined listings can't be selected into a PPU slot.
// Do NOT reuse it for upsells that want combined listings — its exclusion is
// not optional.
export const searchProductsForPostPurchaseUpsellManualSelection = {
  name: "searchProductsForPostPurchaseUpsellManualSelection" as const,
  input: z.object({ search: z.string(), first: z.number().optional() }),
  output: z.array(pickerProductSchema),
};
